import * as React from "react";
import styles from "./Login.module.css";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, styled, ThemeProvider } from "@mui/material/styles";
import logo from "../../Assets/logo.webp";
import Parse from "../../API/ParseServer";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
function Copyright(props: any) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="/">
        Faam Gallery
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();
const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#863a18",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#863a18",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#863a18",
    },
    "&:hover fieldset": {
      borderColor: "#863a18",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#863a18",
    },
  },
});

export default function Login() {
  const [isLogedIn, setIsloggedIn] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const navigate = useNavigate();
  useEffect(() => {
    const currentUser = Parse.User.current();
    if (currentUser) {
      console.log("User is logged in:", currentUser);
      setIsloggedIn(true);
      setErrorMessage("You are already logged in");
    } else {
      console.log("No user is logged in.");
      setErrorMessage("");
    }
  }, []);
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = String(data.get("email"));
    const password = String(data.get("password"));

    try {
      // Log in the user
      if (email && password) {
        const user = await Parse.User.logIn(email, password);
        localStorage.setItem("username", user.get("username"));
        localStorage.setItem("token", user.get("sessionToken"));
        if (localStorage.getItem("guestId")) {
          const prevBasket = await Parse.Cloud.run("getBasket", {
            user: user.id,
          });
          const newBasket = await Parse.Cloud.run("getBasket", {
            user: localStorage.getItem("guestId"),
          });
          if (prevBasket && newBasket.get("items")) {
            newBasket.get("items").forEach(async (item: any) => {
              const response = await Parse.Cloud.run("addToBasket", {
                user: user.id,
                artworkId: item.artwork
                  ? item.artwork.id
                  : item.userArtwork
                    ? item.userArtwork.id
                    : "",
                quantity: item.quantity,
                frameId: item.frame ? item.frame.id : "",
                specifications: item.specifications,
                type: item.type,
                itemId: "",
              });
            });
            newBasket.destroy();
            // let totalQuantity = 0;
            // prevBasket.get("items").forEach((item: any) => {
            //   totalQuantity += item.quantity;
            // });
            // localStorage.setItem("totalQuantity", String(totalQuantity));
          } else if (newBasket.get("items")) {
            await Parse.Cloud.run("loginBasket", {
              user: user.id,
              guestId: localStorage.getItem("guestId"),
            });
          }
          localStorage.removeItem("guestId");
        }
        setErrorMessage("");
        navigate("/");
      }
    } catch (error: any) {
      setErrorMessage("User not found. Please check your information");
      console.log(`Error: ${error.message}`);
    }
  };
  const logoutHandler = () => {
    Parse.User.logOut();
    window.location.reload();
  };
  return (
    <ThemeProvider theme={defaultTheme}>
      <Container
        component="main"
        maxWidth="xs"
        sx={{ height: "calc(100vh - 6rem)" }}
      >
        <CssBaseline />
        <Box
          sx={{
            marginTop: 8,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Link href="/">
            <img src={logo} alt="Faam Gallery" className={styles.logo} />
          </Link>
          {isLogedIn ? (
            <React.Fragment>
              <Typography sx={{ color: "#863a18", mb: 3 }}>
                {errorMessage}
              </Typography>
              <Link href="/" color={"#863a18"}>
                home page
              </Link>
              <button
                style={{
                  background: "transparent",
                  border: "none",
                  outline: "none",
                  color: "#863a18",
                  cursor: "pointer",
                }}
                onClick={logoutHandler}
              >
                log out
              </button>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Typography component="h1" variant="h5">
                Login
              </Typography>

              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{ mt: 3 }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      autoComplete="email"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <CssTextField
                      required
                      fullWidth
                      name="password"
                      label="Password"
                      type="password"
                      id="password"
                      autoComplete="new-password"
                    />
                  </Grid>
                  {/* <Grid item xs={12}>
                <FormControlLabel
                  control={
                    <Checkbox value="allowExtraEmails" color="primary" />
                  }
                  label="I want to receive inspiration, marketing promotions and updates via email."
                />
              </Grid> */}
                </Grid>
                <button className={styles.button}>Login</button>
                <br />
                <br />
                {errorMessage && (
                  <Typography
                    sx={{
                      textAlign: "center",
                      my: 2,
                      color: "#862e18",
                      fontWeight: "bold",
                    }}
                  >
                    {errorMessage}
                  </Typography>
                )}
                <Grid container justifyContent="center">
                  <Grid item>
                    <Link href="/signup" variant="body2" color={"#863a18"}>
                      Don't have an account? Sign Up
                    </Link>
                  </Grid>
                  <Grid item>
                    <Link
                      href="/forget-password"
                      variant="body2"
                      color={"#863a18"}
                    >
                      Forgot your password? click here
                    </Link>
                  </Grid>
                </Grid>
              </Box>
            </React.Fragment>
          )}
        </Box>
        <Copyright sx={{ mt: 5 }} />
      </Container>
    </ThemeProvider>
  );
}
